import axios from 'axios';

const POLICE_URL = process.env.VUE_APP_POLICE_BOT_URL;
const TLV_URL = process.env.VUE_APP_TLV_BOT_URL;
const LOLA_URL = process.env.VUE_APP_LOLA_BOT_URL;
// The shared service hosts every non-TLV/Police/Lola bot, including TlvDocumentCompletion.
// Keep the legacy env var name so deployments don't need new config.
const SHARED_BOTS_URL = process.env.VUE_APP_TLV_DOC_COMPLETION_BOT_URL;

const tlvBotHealth = () => axios.get(`${TLV_URL}/health`);
const policeBotHealth = () => axios.get(`${POLICE_URL}/health`);
const lolaBotHealth = () => axios.get(`${LOLA_URL}/health`);
const sharedBotsHealth = () => axios.get(`${SHARED_BOTS_URL}/api/v1/health`);

const startBot = (baseUrl, botName) => axios.post(`${baseUrl}/api/v1/bot/${botName}/start`);
const stopBot = (baseUrl, botName) => axios.post(`${baseUrl}/api/v1/bot/${botName}/stop`);

const startTlvBot = () => startBot(TLV_URL, 'Tlv');
const stopTlvBot = () => stopBot(TLV_URL, 'Tlv');
const startPoliceBot = () => startBot(POLICE_URL, 'Police');
const stopPoliceBot = () => stopBot(POLICE_URL, 'Police');
const startLolaBot = () => startBot(LOLA_URL, 'Lola');
const stopLolaBot = () => stopBot(LOLA_URL, 'Lola');

const startSharedBot = (botName) => startBot(SHARED_BOTS_URL, botName);
const stopSharedBot = (botName) => stopBot(SHARED_BOTS_URL, botName);

export default {
    tlvBotHealth,
    policeBotHealth,
    lolaBotHealth,
    sharedBotsHealth,
    startTlvBot,
    stopTlvBot,
    startPoliceBot,
    stopPoliceBot,
    startLolaBot,
    stopLolaBot,
    startSharedBot,
    stopSharedBot,
};
